<template>
    <div class="popup-page" id="popup-page">
        <div class="popup-main">
            <img class="popup" src="../../../assets/images/components/img_loading.png" alt="" />
            <div class="popup-content">
                <span>即将进入</span>
                <b>{{ "方德保险" }}</b>
                <span> 销售平台</span>
            </div>
            <div class="popup-time">{{ timerTxt }}</div>
        </div>
    </div>
</template>

<script>
import { bridgeRedirect, setTitle, callHandler } from "../../../utils/bridge";

export default {
    name: "fangdeLoading",
    props: {
        url: String,
        type: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            timerTxt: "02 sec"
        };
    },
    created() {
        setTitle("即将进入方德保险");
        this.showtime(2);
    },
    methods: {
        showtime(t) {
            for (let i = 1; i < t + 1; i++) {
                window.setTimeout(() => {
                    if (i === t) {
                        if (this.type === 1) {
                            //关闭webview
                            callHandler("xhWapGoBack", "wapCloseWeb");
                        } else if (this.type === 2) {
                            // 打开方德产品详情
                            bridgeRedirect({
                                pageParams: {
                                    url: `${this.url}`,
                                    isNeedRemoveWebView: "1"
                                }
                            });
                        }
                    }
                    this.timerTxt = "0" + (t - i) + " sec";
                }, i * 1000);
            }
        }
    }
};
</script>

<style lang="less">
@import "../css/loading.less";
</style>
